import type { RangePickerProps } from 'antd/es/date-picker';
import type { Dayjs } from 'dayjs';

export const disablePickerComparisonDate =
  (mainPeriod: [Dayjs, Dayjs] | null): RangePickerProps['disabledDate'] =>
  (current, { from }) => {
    if (!mainPeriod?.[0] || !mainPeriod?.[1]) return false;

    const mainRange = mainPeriod[1].diff(mainPeriod[0], 'days');

    if (!from) {
      return false;
    }

    return current.isBefore(from) || Math.abs(current.diff(from, 'days')) > mainRange;
  };
